import React, { Component, PureComponent } from 'react';
import ReactDOM from 'react-dom';
import ReactPaginate from 'react-paginate';
import SpotifyPlayer from 'library/SpotifyPlayer';
import BandcampPlayer from 'library/BandcampPlayer';
import SoundcloudPlayer from 'library/SoundcloudPlayer';
import spotifyUri from 'spotify-uri';
import { Sticky, StickyContainer } from 'react-sticky';
import $ from 'jquery';
import Swipeable from 'react-swipeable';

window.React = React;

export class DiscoverBar extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedGenre: 'ALL',
      selectedLanguage: 'ALL',
      selectedYear: 'ALL'
    }
    if (this.props.selectedGenre) {
      let genreNames = this.props.genres.map((genre) => { return genre.toLowerCase() })
      if (genreNames.includes(this.props.selectedGenre.toLowerCase()))
        this.state.selectedGenre = this.props.selectedGenre;
    }
    this.props.genres.unshift('ALL')
    this.props.languages.unshift('ALL')
    this.props.years.unshift('ALL')
  }
  clickAndUpdateGenre = (genre) => {
    this.setState({ selectedGenre: genre })
    this.props.loadAlbumsFromServer(undefined, genre, undefined, true)
  }

  clickAndUpdateLanguage = (language) => {
    this.setState({ selectedLanguage: language})
    this.props.loadAlbumsFromServer(language, undefined, undefined, true)
  }

  clickAndUpdateYear = (year) => {
    this.setState({ selectedYear: year })
    this.props.loadAlbumsFromServer(undefined, undefined, year, true)
  }

  render() {

    let genres = this.props.genres.map((genre) => {
      return (
        <span className={this.state.selectedGenre === genre ? 'item active' : 'item'} key={genre} onClick={() => this.clickAndUpdateGenre(genre)}>{genre}</span>
      )
    });

    let languages = this.props.languages.map((language) => {
      return (
        <span className={this.state.selectedLanguage === language ? 'item active' : 'item'} key={language} onClick={() => this.clickAndUpdateLanguage(language)}>{language}</span>
      )
    });

    let years = this.props.years.map((year) => {
      return (
        <span className={this.state.selectedYear === year ? 'item active' : 'item'} key={year} onClick={() => this.clickAndUpdateYear(year)}>{year}</span>
      )
    })

    return (
      <div className='discover-bar'>
        <div className='container'>
          <div className='col-sm-1 col-12 item-label'>BY GENRES</div>
          <div className='col-sm-11 col-12 item-list'>{genres}</div>
        </div>
        <div className='container'>
          <div className='col-sm-1 col-12 item-label'>BY LANGUAGES</div>
          <div className='col-sm-11 col-12 item-list'>{languages}</div>
        </div>
        <div className='container'>
          <div className='col-sm-1 col-12 item-label'>BY YEAR</div>
          <div className='col-sm-11 col-12 item-list year-list'>{years}</div>
        </div>
      </div>
    )
  }
}

export class FeaturedAlbum extends PureComponent {

  favourite(){
    let a = Object.assign({}, this.props.album);
    a.favourited = true;
    this.props.updateFeaturedItem(a);
    $.ajax({
      url: this.props.album.favourite_path,
      type: 'POST',
      success: data => {
      },
      error: (xhr, status, err) => {
        console.error(this.props.url, status, err.toString());
      }
    });

  }

  unfavourite(){
    let a = Object.assign({}, this.props.album);
    a.favourited = false;
    this.props.updateFeaturedItem(a);
    $.ajax({
      url: this.props.album.unfavourite_path,
      type: 'POST',
      success: data => {
      },
      error: (xhr, status, err) => {
        console.error(this.props.url, status, err.toString());
      }
    });
  }

  render() {
    let { album } = this.props;
    let genres = '';

    if (album.genres !== undefined){
      genres = album.genres.map((genre) => {
        return genre.name
      }).join(', ')
    }

    return(<div className={this.props.mobile ? 'album-card large col-8 offset-2' : 'album-card large col-12'} key={album.id}>
          <div className='image-wrapper'>
            <a href={album.path}><img className='lozad' src={album.image} alt={album.title}/></a>
          </div>
          { this.props.loggedIn &&
          ( album.favourited ?
            <div className="favourite-album-button abs" onClick={()=>this.unfavourite(album)}><i className='fas fa-heart favourited' /></div> :
            <div className="favourite-album-button abs" onClick={()=>this.favourite(album)}><i className='fas fa-heart not-favourited' /></div>
          )
          }
          <a className='album-title' href={album.path}>{album.title}</a>
          {album.artist_paths.length == 1 && <a className='artist-name' href={album.artist_paths[0]}>{album.artist_names[0]}</a>}
          {album.artist_paths.length > 1 &&
            <div className='artist-names'>
              {album.artist_paths.map((path, index) =>
                <a className='artist-name' key={path} href={path}>{album.artist_names[index]}</a>
              )}
            </div>
          }
          <div className='genre-list'>{genres}</div>
        </div>);
  }
}

export class AlbumList extends Component {

  render() {
    let albumNodes = this.props.data.map((album) => {
      let genres = '';
      if (album.genres !== undefined){
        genres = album.genres.map((genre) => {
          return genre.name
        }).join(', ')
      }
      return (
        <div className='album-card col-md-4 col-6'
          key={album.id} onClick={() => this.props.updateFeaturedItem(album)}>
          <div className='image-wrapper hover'>
            <i className='far fa-play-circle fa-4x play-icon' />
            <img className='lozad' src={album.image} alt={album.title} />
          </div>
          <a className='album-title' href={album.path}>{album.title}</a>
          {album.artist_paths.length == 1 && <a className='artist-name' href={album.artist_paths[0]}>{album.artist_names[0]}</a>}
          {album.artist_paths.length > 1 &&
            <div className='artist-names'>
              {album.artist_paths.map((path, index) =>
                <a className='artist-name' key={path} href={path}>{album.artist_names[index]}</a>
              )}
            </div>
          }
          <div className='genre-list'>{genres}</div>
        </div>);
    })
    return (
      <div className={this.props.mobile ? 'row col-4' : 'row'}> {albumNodes} </div>
    )
  }
};

export class Discover extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      cachedData: [],
      selectedGenre: undefined,
      selectedLanguage: undefined,
      selectedYear: undefined,
      offset: this.props.mobile ? 3 : 1,
      pageCount: this.props.pageCount,
      featuredAlbum: this.props.featuredAlbum,
      latest: true,
      is_crawler: this.props.is_crawler,
    }
    if (this.props.selectedGenre) {
      let genreNames = this.props.genres.map((genre) => { return genre.toLowerCase() })
      if (genreNames.includes(this.props.selectedGenre.toLowerCase()))
        this.state.selectedGenre = this.props.selectedGenre;
    }
  }

  // undefined uses previous state.
  loadAlbumsFromServer = (language, genre, year, reset = false) => {
    let anyChanged = false;
    const { selectedLanguage, selectedGenre, selectedYear, offset } = this.state;

    if (reset){
      this.setState({ offset: 0 });
    }
    if (genre) {
      if (genre !== selectedGenre)
        anyChanged = true;
      this.setState({ selectedGenre: genre });
    }
    if (language) {
      if (language !== selectedLanguage)
        anyChanged = true;
      this.setState({ selectedLanguage: language });
    }

    if (year) {
      if (year !== selectedYear)
        anyChanged = true;
      this.setState({ selectedYear: year });
    }

    let data = { offset: reset ? 0 : offset }

    if (genre !== 'ALL')
      if (genre === undefined && selectedGenre !== 'ALL')
        data['genre'] = selectedGenre
      else
        data['genre'] = genre

    if (language !== 'ALL')
      if (language === undefined && selectedLanguage !== 'ALL')
        data['language'] = selectedLanguage
      else
        data['language'] = language

    if (year !== 'ALL')
      if (year === undefined && selectedYear !== 'ALL')
        data['year'] = selectedYear
      else
        data['year'] = year

    if (anyChanged && this.props.mobile)
      data['per'] = 18

    $.ajax({
      url: this.props.url,
      data: data,
      dataType: 'json',
      type: 'GET',

      success: data => {
        // set state
        if (this.props.mobile) {
          // shift the data back.
          if (anyChanged) {
            this.setState({
              cachedData: [],
              data: data.results,
              pageCount: data.count,
              offset: 3 })
          } else {
            this.setState({
              cachedData: this.state.cachedData.concat(this.state.data.slice(0, 6)),
              data: this.state.data.slice(6).concat(data.results),
              pageCount: data.count })
          }

          this.swipeableEl.style.transform = `translate3d(0, 0, 0)`;
          this.swipeableEl.style.transition = 'none';
          const indicator = document.querySelector('.page-indicator')
          if (indicator)
            indicator.style.margin = `0 ${5+80*(this.state.offset/data.count)}vw`;
        } else {
          this.setState({ data: data.results, pageCount: data.count });
        }
      },

      error: (xhr, status, err) => {
        console.error(this.props.url, status, err.toString());
      }
    });
  }

  swiping = (e, deltaX, deltaY, absX, absY, velocity) => {
    if (velocity < 0.6 && deltaX > 20){
      this.swipeableEl.style.transform = `translate3d(${-deltaX}px, 0, 0)`;
    }
  }

  swipedLeft = (e, deltaY, isFlick) => {
    const { offset, pageCount } = this.state;
    if (offset < pageCount - 1){
      if (isFlick){
        this.swipeableEl.style.transition = 'transform 0.1s ease-out'
        this.swipeableEl.style.transform = 'translate3d(-100vw, 0, 0)';
      }
      this.setState({ offset: offset+1 }, () => {
        this.loadAlbumsFromServer(this.state.selectedLanguage, this.state.selectedGenre, this.state.selectedYear);
      })
    } else {
      this.swipeableEl.style.transition = 'transform 0.1s ease-out'
      this.swipeableEl.style.transform = 'translate3d(0, 0, 0)';
    }
  }

  swipedRight = (e, deltaY, isFlick) => {
    const { offset, cachedData } = this.state;
    if (cachedData.length !== 0){
      if (isFlick){
        this.swipeableEl.style.transition = 'transform 0.1s ease-out'
        this.swipeableEl.style.transform = 'translate3d(100vw, 0, 0)';
      }
      this.setState({ offset: offset-1,
        data: cachedData.slice(-6).concat(this.state.data.slice(0, 12)),
        cachedData: cachedData.slice(0, cachedData.length - 6)});
      this.swipeableEl.style.transform = `translate3d(0, 0, 0)`;
      this.swipeableEl.style.transition = 'none'
    } else {
      this.swipeableEl.style.transition = 'transform 0.1s ease-out'
      this.swipeableEl.style.transform = 'translate3d(0, 0, 0)';
    }
  }

  handlePageClick = (data) => {
    let selected = data.selected;
    this.setState({ offset: ++selected }, () => {
      this.loadAlbumsFromServer(this.state.selectedLanguage, this.state.selectedGenre, this.state.selectedYear);
    });
  };

  updateFeaturedItem = (album) => {
    this.setState({featuredAlbum: album, latest: false});
  }

  updateFavouriteState = (album) => {
    let albums = [...this.state.data];
    let id  = 0
    albums.forEach((a, index) => {
      if (a.id === album.id){
        id = index;
      }
    })
    albums.splice(id, 1, album)
    this.setState({data: albums, featuredAlbum: album, latest: false});
  }

  componentDidMount() {
    //this.loadAlbumsFromServer(this.state.selectedLanguage, this.state.selectedGenre, this.state.selectedYear);
    this.setState({ data: this.props.albums, pageCount: this.props.pageCount })
  }

  render() {
    const { data, featuredAlbum, pageCount, latest } = this.state;
    const { selectedGenre, languages, years, mobile, genres, is_crawler } = this.props;

    let paginate = <div className='no-albums'>No albums found with the selected categories.</div>
    if (pageCount > 1) {
      if (!mobile)
        paginate = <ReactPaginate previousLabel={'previous'}
          nextLabel={'next'}
          breakLabel={<a href=''>...</a>}
          breakClassName={'break-me'}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={this.handlePageClick}
          containerClassName={'row nav navbar discover-navbar'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'} />
      else
        paginate = <div className='page-indicator'/>
    } else {
      paginate = null;
    }

    let mediaPlayer = null;
    let hasSpotify = featuredAlbum.outlets.spotify !== undefined && featuredAlbum.outlets.spotify.length != 0;
    let hasBandcamp = featuredAlbum.outlets.bandcamp !== undefined && featuredAlbum.outlets.bandcamp.length != 0;
    let hasSoundcloud = featuredAlbum.outlets.soundcloud !== undefined && featuredAlbum.outlets.soundcloud.length != 0;
    if (!is_crawler) {
      if (hasSpotify) {
        let parsed = spotifyUri.parse(featuredAlbum.outlets.spotify);
        let uri = spotifyUri.formatURI(parsed);
        let spotifyContent =
          <SpotifyPlayer
          uri={uri}
          size='compact'
          view='coverart'
          theme='white'
        />
        if (this.props.mobile){
          mediaPlayer =
          <Sticky topOffset={50}>
            {({
              isSticky
            }) => <div className={isSticky ? 'sticky-spotify' : ''}>{spotifyContent}</div> }
          </Sticky>
        } else {
          mediaPlayer = spotifyContent;
        }
      } else if (hasBandcamp) {
        let uri = featuredAlbum.outlets.bandcamp;
        let bandcampContent =
          <BandcampPlayer
            src={uri}
            size="large"
            tracklist="false"
            artwork="small"
            height="120px"
          />
          if (this.props.mobile){
            mediaPlayer =
            <Sticky topOffset={50}>
              {({
                isSticky
              }) => <div className={isSticky ? 'sticky-spotify' : ''}>{bandcampContent}</div> }
            </Sticky>
          } else {
            mediaPlayer = bandcampContent;
          }
      } else if (hasSoundcloud) {
        let uri = featuredAlbum.outlets.soundcloud;
        let soundcloudContent =
          <SoundcloudPlayer
            url={uri}
          />
          if (this.props.mobile){
            mediaPlayer =
            <Sticky topOffset={50}>
              {({
                isSticky
              }) => <div className={isSticky ? 'sticky-spotify' : ''}>{soundcloudContent}</div> }
            </Sticky>
          } else {
            mediaPlayer = soundcloudContent;
          }
      }
    }
    if (mobile)
      return (
        <div>
          <div className='col-md-4 col-12 albums'>
            <FeaturedAlbum album={featuredAlbum} mobile={true} loggedIn={this.props.loggedIn} updateFeaturedItem={this.updateFavouriteState} />
          </div>
          <DiscoverBar genres={genres} selectedGenre={selectedGenre} languages={languages} years={years} loadAlbumsFromServer={this.loadAlbumsFromServer} />
          <StickyContainer>
            <div className='container'>
              { mediaPlayer }
              { mediaPlayer ? <a class="d-block button" href={featuredAlbum.path} >REVIEW</a> : null }
              <div className='row discover-albums' style={{width: '350%'}}>
                <div className='col-12 albums' style={{padding: 0}}>
                  <Swipeable className='swipe-container'
                    preventDefaultTouchmoveEvent={true}
                    onSwiping={this.swiping}
                    onSwipedLeft={this.swipedLeft}
                    onSwipedRight={this.swipedRight}
                    innerRef={(el) => this.swipeableEl = el}>
                    <AlbumList data={data.slice(0, 6)} updateFeaturedItem={this.updateFeaturedItem} mobile={true} />
                    <AlbumList data={data.slice(6, 12)} updateFeaturedItem={this.updateFeaturedItem} mobile={true} />
                    <AlbumList data={data.slice(12)} updateFeaturedItem={this.updateFeaturedItem} mobile={true} />
                  </Swipeable>
                  { paginate }
                </div>
              </div>
            </div>
          </StickyContainer>
        </div>
      )
    return (
      <div>
        <DiscoverBar genres={genres} selectedGenre={selectedGenre} languages={languages} years={years} loadAlbumsFromServer={this.loadAlbumsFromServer} />
        <div className='container'>
          <div className='row discover-albums'>
            <div className='col-md-8 col-12 albums'>
              <AlbumList data={data} updateFeaturedItem={this.updateFeaturedItem} />
              { paginate }
            </div>
            <div className='col-md-4 col-12 albums'>
              { latest && <label className='latest-label'>Latest</label> }
              <FeaturedAlbum album={featuredAlbum} loggedIn={this.props.loggedIn} updateFeaturedItem={this.updateFavouriteState} />
              <div className='col-12'>
                { mediaPlayer }
                { mediaPlayer ? <a class="d-block button" href={featuredAlbum.path} >REVIEW</a> : null }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};
